import { all } from '../services/restApi'
import { batchObject, batchArray } from '../services/batch'
import { message } from 'antd'
import config from '../utils/config'
message.config({top: 110, duration: 4});
const _ = require('underscore')

const limit = 50;

export default {
	namespace : 'receptionist',
	state : {
		receptionists: [],
		skip: 0,
		limit: limit,
		total_items: 0
	},
	subscriptions : {
		setup({dispatch, history}) {

			history.listen(location => {
		        if (location.pathname === '/all_users/list-receptionists') {
		          	dispatch({type: 'firstLoad'})
		        }
		    })
		}
	},
	effects : {
		*firstLoad({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {
				let query = {type: 'recepcionista'};
				
				if (localStorage.getItem('currentHotel') && JSON.parse(localStorage.getItem('currentHotel')).objectId) 
					query.hotels = {$all: [{__type: 'Pointer', className: 'Hotel', objectId: JSON.parse(localStorage.getItem('currentHotel')).objectId}]}

				const resp = yield call(all, '_User', {
					where: query,
					include: 'hotels',
					skip: 0, limit: limit, count: 1, order: '-createdAt'
				})
				const receptionists = resp.results;

				yield put({ type: 'queryFirst', payload: {
					receptionists: receptionists, 
					skip: limit,
					total_items: resp.count,
				}})

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')
			}

			yield put({type: 'app/hideLoadingTable'})
		},
		*query({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {
				// Model
				const data = {...payload, 
					include: 'hotels'
				};

				const resp = yield call(all, '_User', data)
				const receptionists = resp.results;

				yield put({ type: 'querySuccess', payload: {
					receptionists: receptionists,
					skip: data.skip + limit,
					total_items: resp.count
				}})

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')
			}

			yield put({type: 'app/hideLoadingTable'})
		},
		*update({payload}, {call, put}) {
			yield put({type: 'app/showButtonLoading'})

			try {
				// Model
				let data = {...payload};
		        data._method = "PUT";

		        data.hotels = [];
		        payload.hotels.map(item => {
		        	return data.hotels.push({ __type: 'Pointer', className: 'Hotel', objectId: item.objectId });
		        });

				data = _.omit(data, ['createdAt', 'updatedAt']);			

				yield call(batchObject, '_User', data.objectId, data._method, data)
				yield put({ type: 'updateSuccess', payload: {...data, hotels: payload.hotels, objectId: payload.objectId} })
				message.success('Se ha actualizado el recepcionista exitosamente');

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')	
			}

			yield put({type: 'app/hideButtonLoading'})

		},
		*removeItem({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {
				// Model
				let data = {};
		        data.requests = [{method: "DELETE", path: "/"+ config.slug +"/classes/_User/" + payload.objectId}];

				yield call(batchArray, data);
				yield put({type: 'removeSuccess', payload: payload})

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')	
			}

			yield put({type: 'app/hideLoadingTable'})

		}
	},
	reducers : {
		queryFirst(state, action) {
			return {
				...state,
				...action.payload
			}
		},
		querySuccess(state, action) {
			return {
				...state,
				receptionists: state.receptionists.concat(action.payload.receptionists),
				skip: action.payload.skip,
				total_items: action.payload.total_items
			}
		},
		updateSuccess(state, action) {
			const obj = _.find(state.receptionists, {objectId: action.payload.objectId})
			_.extend(obj, action.payload)
			
			return {
				...state,
    			...action.payload
			}
		},
		removeSuccess(state, action) {
			return {
				...state,
    			receptionists: _.without(state.receptionists, action.payload)
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/models/recepcionist.js